"use strict";import{tag as o}from"../custom-tag.js";export function tooltipIcon({height:t=16,width:l=16,hidden:e=!1,title:a="Tooltip"}={}){return o`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${e?"true":"false"}"
      role="img"
      aria-label="${a}"
    >
      <mask
        id="tooltip_svg__mask0_6875_6568"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m.526 14.75h-1.052v-6.316h1.052zm0-8.434h-1.052V7.263h1.052z"
        />
      </mask>
      <g mask="url(#tooltip_svg__mask0_6875_6568)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=tooltip.js.map
